/**
 * SalesOrderOS brand lockup: monogram tile + "SalesOrderOS" wordmark, with an
 * optional "by Xamun" endorsement. `tone="light"` is for dark backgrounds.
 */
export default function BrandLockup({ tone = 'dark', endorse = false, className = '' }) {
  return (
    <span className={`brand-lockup brand-lockup--${tone} ${className}`.trim()}>
      <img className="brand-lockup__mark" src="/assets/salesorderos-icon.svg" alt="" aria-hidden="true" />
      <span className="brand-lockup__text">
        <span className="brand-lockup__name">
          SalesOrder<b>OS</b>
        </span>
        {endorse && (
          <span className="brand-lockup__by">
            by{' '}
            <img
              src={tone === 'light' ? '/assets/xamun-logo-light.png' : '/assets/xamun-logo-dark.png'}
              alt="Xamun.AI"
            />
          </span>
        )}
      </span>
    </span>
  );
}
